import React from "react";
import { useTranslation } from "react-i18next";
import { FormGroup, FormControlLabel, Switch, FormHelperText } from "@mui/material";
import { Controller } from "react-hook-form";

const CustomSwitch = ({
  name,
  label,
  control,
  errors,
  disabled,
  onChange: externalOnChange, // optional
}) => {
  const { t } = useTranslation();

  return (
    <FormGroup>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <>
            <FormControlLabel
              control={
                <Switch
                  checked={Boolean(field.value)}
                  disabled={disabled}
                  onChange={(e) => {
                    field.onChange(e.target.checked); // RHF
                    externalOnChange?.(e.target.checked); // Parent hook
                  }}
                />
              }
              label={t(label)}
            />

            {errors?.[name] && <FormHelperText error>{errors[name]?.message}</FormHelperText>}
          </>
        )}
      />
    </FormGroup>
  );
};

export default React.memo(CustomSwitch);
